// This file is auto-generated by dibs-icons script
import { type FC } from 'react';
import LightBulb12CircleFilled from './LightBulb12CircleFilled';
import LightBulb20 from './LightBulb20';
import LightBulb20Filled from './LightBulb20Filled';
import LightBulb20CircleFilled from './LightBulb20CircleFilled';
import LightBulb24 from './LightBulb24';
import LightBulb24Filled from './LightBulb24Filled';
import LightBulb24CircleFilled from './LightBulb24CircleFilled';
import LightBulb40 from './LightBulb40';
import LightBulb40Filled from './LightBulb40Filled';
import LightBulb48 from './LightBulb48';
import LightBulb48Filled from './LightBulb48Filled';

type LightBulbProps = {
    variation:
        | '12CircleFilled'
        | '20'
        | '20Filled'
        | '20CircleFilled'
        | '24'
        | '24Filled'
        | '24CircleFilled'
        | '40'
        | '40Filled'
        | '48'
        | '48Filled';
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const svgVariations = {
    LightBulb12CircleFilled,
    LightBulb20,
    LightBulb20Filled,
    LightBulb20CircleFilled,
    LightBulb24,
    LightBulb24Filled,
    LightBulb24CircleFilled,
    LightBulb40,
    LightBulb40Filled,
    LightBulb48,
    LightBulb48Filled,
};

const LightBulb: FC<LightBulbProps> = ({ variation, ...props }) => {
    const variationKey = `LightBulb${variation}` as keyof typeof svgVariations;
    const Icon = svgVariations[variationKey];

    if (!Icon) {
        // eslint-disable-next-line no-console
        console.error(`"LightBulb" icon variation ${variationKey} does not exist`);
        return null;
    }

    return <Icon {...props} />;
};

export default LightBulb;
